module.exports = __webpack_public_path__ + "img/made-in-germany.17ddd4f1.png";